export default function initModal() {
    const closeButtons = document.querySelectorAll('[data-button-modal-close]');
    closeButtons.forEach((closeButton) => {
      closeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        closeButton.closest('.modal-active').classList.remove('modal-active');
      });
    });

}
